const LOG_SETUP_PER_SESSION = "LOG_SETUP_PER_SESSION";

const fromJsonToString = (jsonData) => {
    return JSON.stringify(jsonData);
}

const fromStringToJson = (string) => {
    return JSON.parse(string);
}

const saveAuthorizationToken = (data) => {
    if (data.authorization) {
        sessionStorage.setItem("authorization", data.authorization);
        delete data.authorization;
        return data;
    }
}

const isSetupDefined = () => {
    return sessionStorage.getItem(LOG_SETUP_PER_SESSION);
}

const defineSetup = () => {
    sessionStorage.setItem(LOG_SETUP_PER_SESSION, false);
}

export default { 
    fromJsonToString, 
    fromStringToJson, 
    saveAuthorizationToken,
    isSetupDefined,
    defineSetup
};